import { useState, useEffect } from "react";
import { API } from "../../services/api/API";
import { CurrentUser } from "../login/CurrentUser";
import SocketClient from "../../services/socket/SocketClient";




export default function useSocketClientInfo() {
    
    const [state, setState] = useState(false);    
    
    SocketClient.OnDocWinSocketStatusChange.Add(setState);      

    let [status, setStatus] = useState({
        Online: false,
        Machine: 'Aguardando login...'
    });

    useEffect(() => {
        
        const fetchStatus = async () => {
            let checkStatusResponse;

            try {
                checkStatusResponse = await API.RequestAsync(
                    `/data/has-instances?licenseNumber=${CurrentUser.User?.Licence.Number}`,
                    CurrentUser.Token!.Token,
                    'GET'
                );
            } catch {
                checkStatusResponse = undefined;
            }

            if (!checkStatusResponse || !checkStatusResponse.ok) {            
                setStatus({ Online: false, Machine: "" });
                return;
            }

            const statusJson = await checkStatusResponse.json();  

            setStatus({
                Online: true,
                Machine: statusJson.Machine
            });
        };

        fetchStatus();
    }, [state]);
   
   return status;
}
